// extracted by mini-css-extract-plugin
export default {"base":"ActionViewMod_base__KCyAc","isDisabled":"ActionViewMod_isDisabled__feu7j"};